import React, {Component} from 'react'
import PropTypes from 'prop-types'
import NextPagination from "../../../components/Pagination/NextPagination"


class ListBoxPagination extends Component {

    render() {
        const {page, limit, loading, total, onChange} = this.props

        return (
            <div className="ListBoxPagination mt-3 d-flex">
                <NextPagination onChange={onChange} limit={limit} total={total} page={page} loading={loading}/>
                <strong className="BoxesCounter">{total} {total > 1 ? 'boxes' : 'box'}</strong>
            </div>
        )
    }
}

ListBoxPagination.defaultProps = {
    loading: false,
}


ListBoxPagination.propTypes = {
    page: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
}

export default ListBoxPagination
